var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b01291ea-fbbe-47ab-bc44-77c1e3f541c5",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a3094cdc-49d2-461b-b9da-5bf6e856489d",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34,16.66a6.57,6.57,0,0,1,0-9.32L8.9,8.9A4.31,4.31,0,0,0,7.6,12a4.38,4.38,0,0,0,1.29,3.11Zm9.32,0a6.57,6.57,0,0,0,0-9.32L15.1,8.9A4.31,4.31,0,0,1,16.4,12a4.38,4.38,0,0,1-1.29,3.11ZM12,9.8A2.2,2.2,0,1,0,14.2,12,2.21,2.21,0,0,0,12,9.8ZM20.8,12a8.7,8.7,0,0,1-2.59,6.21l1.57,1.57a11,11,0,0,0,0-15.56L18.21,5.79A8.7,8.7,0,0,1,20.8,12Zm-15-6.21L4.22,4.22a11,11,0,0,0,0,15.56l1.57-1.57a8.75,8.75,0,0,1,0-12.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorSignal);
export default __webpack_public_path__ + "static/media/sensor-signal.114b9b9cfb45c399870a4ef56f842c22.svg";
export { ForwardRef as ReactComponent };